import { AfterViewInit, Component, inject, OnDestroy, ViewChild } from '@angular/core';
import { ZXingScannerComponent, ZXingScannerModule } from '@zxing/ngx-scanner';
import { ContinuousQrScanningService } from '@data-terminal/ui-smart/services/continuous-qr-scanning.service';

const TWO_HUNDRED = 200;

@Component({
    selector: 'data-terminal-qr-background-scanner',
    imports: [ZXingScannerModule],
    template: `
        <zxing-scanner
            #scanner
            [torch]="false"
            [tryHarder]="true"
            [autofocusEnabled]="true"
            [enable]="false"
            (deviceChange)="onDeviceChange()"
        ></zxing-scanner>
    `,
    styles: `
        :host {
            display: none;
        }
    `,
})
export class BackgroundScannerComponent implements AfterViewInit, OnDestroy {
    readonly #continuousQrScanningService = inject(ContinuousQrScanningService);

    @ViewChild('scanner') scanner!: ZXingScannerComponent;

    public ngAfterViewInit(): void {
        this.#continuousQrScanningService.attachScanner(this.scanner);
    }

    public ngOnDestroy(): void {
        this.#continuousQrScanningService.detachScanner();
    }

    public onDeviceChange(): void {
        setTimeout(() => {
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const controls = this.scanner?.codeReader?.getScannerControls() as any;
                (
                    controls?.streamVideoConstraintsApply(this.#buildVideoConstraints()) as Promise<void> | undefined
                )?.catch(() => {
                    /* constraints not supported by this device/browser */
                });
            } catch {
                /* no scanning session active yet */
            }
        }, TWO_HUNDRED);
    }

    #buildVideoConstraints(): MediaTrackConstraints {
        return {
            facingMode: { ideal: 'environment' },
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            advanced: [{ focusMode: 'continuous' } as MediaTrackConstraintSet],
        };
    }
}
